"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../../..");

var _metrics = require("../../../_helpers/metrics");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Link.css");

var _styles = {
  "link": "Link__link___1oo5P",
  "disable-selection": "Link__disable-selection___249UE",
  "underline": "Link__underline___3Y9wL",
  "disabled": "Link__disabled___3e2Yd",
  "inherit-color": "Link__inherit-color___3Wtej",
  "external": "Link__external___YDrwp",
  "regular": "Link__regular___yCuSe",
  "medium": "Link__medium___2m7eh",
  "italic": "Link__italic___2PmLR",
  "regular-all-caps": "Link__regular-all-caps___2W-Em",
  "medium-all-caps": "Link__medium-all-caps___uiZXj",
  "italic-all-caps": "Link__italic-all-caps___3Kyq7"
};

const styles = _bind.default.bind(_styles);

const Link = (0, _mobxReact.observer)(({
  className,
  children,
  onClick,
  external,
  disabled = false,
  inheritColor,
  target = external ? '_blank' : '_self',
  variant = 'regular',
  href,
  rel = 'noopener noreferrer',
  underline,
  text,
  size,
  dataTestId,
  disableSelection = false,
  iconSize = 18,
  omitIcon = false,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('link', variant, {
    external: external || target === '_blank',
    underline,
    disabled,
    'disable-selection': disableSelection,
    'inherit-color': inheritColor
  }), className);
  const composed_styles = {
    fontSize: `${size}px`
  };
  return _react.default.createElement("a", {
    className: composed_classname,
    onClick: e => {
      if (disabled) {
        e.stopPropagation();
        e.preventDefault();
      } else if (onClick) {
        if (dataTestId) {
          (0, _metrics.trackAction)(`click on ${dataTestId}`);
        }

        onClick();
      }
    },
    target: target,
    href: href,
    rel: rel,
    style: composed_styles,
    "data-testid": dataTestId,
    "data-dd-action-name": dataTestId,
    ...props
  }, children || text, !omitIcon && (external || target === '_blank') && _react.default.createElement(_.Icon, {
    name: _.IconEnum.external_link,
    size: iconSize
  }));
});
var _default = Link;
exports.default = _default;